import { observable, action, computed } from 'mobx';

import { AppManager } from 'core';

import { ProcessMonitorQuery } from 'apps/processMonitor/gql';
import {
  ProcessMonitorModel,
  ProcessMonitorApp,
} from 'apps/processMonitor/app';

export class ProcessMonitorAppManager extends AppManager {
  static registryName = 'ProcessMonitorAppManager';
  @observable minimised = true;
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('currentProcess', ProcessMonitorApp);
    this.NewProcessMonitorQuery();
  }

  @action SetMinimised = bool => {
    this.minimised = bool;
  };

  @action NewProcessMonitorQuery = () => {
    this.processMonitorQuery = new ProcessMonitorQuery(this, {
      queryKey: 'processMonitor',
    });
    this.processMonitorQuery.process(
      result =>
        result &&
        result.pendingOperationProjects &&
        ProcessMonitorModel.Load(result),
      this.LoadProcessMonitor,
    );
    this.processMonitorQuery.query();
  };

  @computed get loading() {
    return !this.processMonitorQuery || this.processMonitorQuery.loading;
  }

  @action LoadProcessMonitor = model => {
    if (model) {
      this.currentProcess = model;
    }
  };
}
